<template>
	<div style="padding-top: 85px;">
		<headerList></headerList>
		
		<div class="detail-box">
			<!-- 详情版心主要内容 -->
			<div  class="detail-main">
				<div class="ptb-15 flex flex-y- flex-x-s f-14 c-66">
					<span>当前位置: </span>
					<span class="ml-5">首页</span>
					<span class="iconfont iconxiangyoujiantou mlr-5"></span>
					<span>{{SYS_TOPIC}}</span>
				</div>
				
				<div class="flex flex-y-s">
					<!-- 左侧内容 -->
					<div class="news_list_box bg-ff plr-40 pt-30 pb-60">
						<!-- 标题 -->
						<p class="f-30 bold c-29">{{SYS_TOPIC}}</p>
						<!-- 文章信息 -->
						<div class="mt-10">
							<div class="f-14 c-99">
								<span>{{XINWENZIXUN_PUB_DATE}}</span>
								<span class="ml-10">来源: {{XINWENZIXUN_DOC_SOURCE}}</span>
							</div>
							<div></div>
						</div>
						<!-- 版权说明 -->
						<div class="banquansm plr-10 ptb-15 f-14 c-99 mt-30 mb-20">凡市场星报、图片安徽网记者署名文字、图片，版权均属于市场星报所有。任何媒体、网站或者个人，未经授权不得转载、链接、转帖或以其他方式复制发表；已经授权的媒体、网站，在转载使用时必须注明“来源：图片安徽网、市场星报”，违者本单位将依法追究法律责任。</div>
						<div v-html="XINWENZIXUN_DOC_EXPLAIN" class="news_detail_box"></div>
					</div>
					<!-- 右侧内容 -->
					
					<div class="flex flex-y-s">
						<!-- 右侧内容 -->
						<div class="right_content">
							<!-- 栏目新闻 -->
							<div class="news_like bg-ff">
								<div class="title plr-30 flex flex-x-s b-b"> <span class="f-18 c-29 ml-10">栏目新闻</span></div>
								<ul class="plr-30 over  pb-20">
									<li @click="bindlinkTo(item.id)" class="news_like_detail mt-15" v-for="item,index in new_like" v-show="index == 0">
										<div class="flex"> 
											<div class="date-box mr-10 f-12 c-ff">{{item.year}}-</div>
											<div class="f-16 c-66 onelist flex-box">{{item.SYS_TOPIC}}</div>
										</div>
										<div class="flex mt-10">
											<img class="mr-10" :src="item.pub_cover" alt="" />
											<div class="flex-box f-14 c-99 twolist">{{item.XINWENZIXUN_REMARK}}</div>
										</div>
									</li>
									<li @click="bindlinkTo(item.id)" class="news_like_detail mt-15" v-for="item,index in new_like" v-show="index > 0">
										<div class="flex">
											<div class="date-box mr-10 noone f-12 c-ff">{{item.year}}-</div>
											<div class="f-16 c-66 onelist flex-box">{{item.SYS_TOPIC}}</div>
										</div>
									</li>
								</ul>
							</div>
							<!-- 热门图片 -->
							<div class="news_like bg-ff mt-20">
								<div class="title plr-30 flex flex-x-s b-b"> <span class="f-18 c-29 ml-10">热门图片</span></div>
								<ul class=" over">
									<li class="news_like_detail img p-10 b-t flex" v-for="item,index in hot_list" v-show="index < 4" @click="enterDetail(item.docId,item.doclibId)">
										<img :src="item.COVERPATH" alt="" class="mr-10 radius-5" />
										<div class="flex-box">
											<p class="f-16 c-33 onelist">{{item.SYS_TOPIC}}</p>
											<div class="flex flex-x-s f-14 c-99 mt-10">
												<p>{{item.date}}</p>
												<p class="ml-10">浏览量 {{item.CLICK_COUNT?item.CLICK_COUNT:0}}</p>
											</div>
										</div>
									</li>
								</ul>
							</div>
						</div>
						
					</div>
					
				</div>
				
			</div>
		</div>
		<footer-view></footer-view>
	</div>
</template>

<script>
import footerView from './footer.vue'
import headerList from './header_nav.vue'
export default {
  data () {
    return {
			id:0,
			newsDetail: null,
			SYS_TOPIC:'', // 资讯标题
			XINWENZIXUN_DOC_SOURCE:'', // 资讯来源
			XINWENZIXUN_REMARK:'', // 资讯备注
			XINWENZIXUN_DOC_EXPLAIN:'', // 资讯富文本
			XINWENZIXUN_PUB_DATE:'', // 资讯日期
			new_like: [], // 新闻列表_排行榜
			hot_list:[]
		}
  },
	
	components: {
		headerList,
		footerView
	},

  created () {
		let _this = this
		this.id = this.$route.query.id
		this.getnewsinfo(this.id)
		this.getnewslike()
		this.getimgLike()
	},

  methods: {

		 // 获取新闻详情
		 async getnewsinfo (pubId) {
		 	let _this = this
			let datainfo = {
				siteId: 101,
				colld: 4,
				pubId
			}
			_this.$Spin.show()
		 	const res = await _this.get('/resource/detail.do', datainfo )
			console.log(res);
		 	if ( res.successResult) {
				_this.SYS_TOPIC = res.data.SYS_TOPIC
				_this.XINWENZIXUN_DOC_SOURCE = res.data.XINWENZIXUN_DOC_SOURCE
				_this.XINWENZIXUN_REMARK = res.data.XINWENZIXUN_REMARK
				_this.XINWENZIXUN_DOC_EXPLAIN = res.data.XINWENZIXUN_DOC_EXPLAIN
				console.log("141111",res.data.XINWENZIXUN_PUB_DATE);
				_this.XINWENZIXUN_PUB_DATE = _this.util.formatDate(res.data.XINWENZIXUN_PUB_DATE)
				// _this.SYS_TOPIC = res.data.SYS_TOPIC
				// _this.SYS_TOPIC = res.data.SYS_TOPIC
				// _this.SYS_TOPIC = res.data.SYS_TOPIC
				// _this.SYS_TOPIC = res.data.SYS_TOPIC
				document.title=_this.SYS_TOPIC
				_this.$Spin.hide()
		 	}
		 },
		 
		 // 跳转
		 bindlinkTo (id) {
		 	this.$router.push({path:'/news_detail',query: {id}})
		 },
		 
		 // 获取新闻列表——拍上榜
		 async getnewslike (page) {
		 	let _this = this
		 	let data = { 
		 				conditions:JSON.stringify([{pub_col_id:4},{pub_resource_type:"XINWENZIXUN"}]),
		 				orderBy: "pub_a_order asc pub_lastmodified desc id asc",
		 				groupBy: "pub_resource_id",
		 				pageNo:1,
		 				pageSize:6,
		 				searchText:"",
		 			}
		 	const res = await _this.post('/spc/cms/publish/list.do', data )
		 	if ( res.success) {
		 				res.result.forEach( x => {
		 					x.date = _this.util.formatDate(x.XINWENZIXUN_PUB_DATE)
		 					x.year = x.date.substr(0,4)
		 				})
		 			 _this.new_like = res.result
		 	} else {
		 			_this.$Message.error(res.description);
		 	}
		 },
		 
		 // 获取图片排行
		 async getimgLike () {
		 			 let _this = this
		 			 const res = await _this.get_res('/search?t=25&size=5&page=0&sld=AHSCXB&sort=CLICK_1_0_l,desc')
		 			 _this.hot_list = res.content
		 },
		 
		 // 跳转
		 enterDetail (id,tid) {
		 	if (tid == 25 || tid == 837) {
		 				this.$router.push({path:'/img_detail',query: {id,tid}})
		 			} else if (tid == 28) {
		 				this.$router.push({path:'/audio_detail',query: {id,tid}})
		 			} else {
		 				this.$router.push({path:'/video_detail',query: {id,tid}})
		 			}
		 },
	},
	
	// 监听器监听路由的变化
	watch: {
		'$route'(to,from) {
			this.id = this.$route.query.id
			this.getnewsinfo(this.id)
		}
	},
	

}
</script>

<style lang="less" scoped>
	
	.detail-box {
		background-color: #f1f2f6;
		padding-bottom: 120px;
		
	}
	.detail-main {
		width: 1200px;
		margin: 0 auto;
	}
	.iconxiangyoujiantou {
		font-size: 12px;
		color: #666;
	}
	
	// 新闻列表
	.news_list_box {
		width: 800px;
		.banquansm {
			background-color: #f6fafd;
			border: 1px solid #ccc;
			text-indent: 2em;
		}
		img {
			max-width: 600px;
			height: auto;
			margin: 20px auto;
			display: block;
		}
	}
// 右侧内容
	.right_content {
		width: 380px;
	}
	.news_like {
		.title {
			height: 48px;
		}
		.title::before {
			content: '';
			height: 16px;
			width: 2px;
			background-color: #0e0963;
		}
	}
	.news_like_detail {
		cursor: pointer;
		.date-box {width: 40px;height: 20px;background-color: #0e0963;text-align: center;line-height: 20px;}
		img {width: 105px;height: 60px;}
		.date-box.noone {background-color: #b2b3ad;}
	}
	.news_like_detail.img {
		cursor: pointer;
		img {width: 110px;height: 70px;}
	}
	
	.news_detail_box {
		line-height: 25px;
		font-size: 16px;
		color: #292929;
		p {
			margin: 10px 0;
		}
	}
</style>
